import { createFileRoute, redirect } from '@tanstack/react-router';

// AB#594: Team moved under the Account section. Keep the old path alive for
// bookmarks/deep links by redirecting to its new home.
export const Route = createFileRoute('/team')({
  beforeLoad: () => {
    throw redirect({ to: '/account/team', replace: true });
  },
});
